import React from 'react';
import styles from './OMTwinInput.scss';

const OMTwinInput = properties => (
  <div className={styles[properties.className]}>
    <div className={styles.inputWrapper}>
      <input type="text" pattern="\d+ || ''" {...properties.field.min} placeholder={properties.minPlaceholder} />
      <div className={styles.title}>{properties.minTitle}</div>
    </div>
    <div>{properties.separator}</div>
    <div className={styles.inputWrapper}>
      <input type="text" {...properties.field.max} placeholder={properties.maxPlaceholder} onBlur={properties.checkMaxValue} />
      <div className={styles.title}>{properties.maxTitle}</div>
    </div>
  </div>
);

export default OMTwinInput;

